var _style, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.3 457.5",
    style: {
      enableBackground: "new 0 0 511.3 457.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#15294C;}\n\t.st1{fill:#9ACA3D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.7,221.7L439.8,35.9h-86.9c-18,0.2-33.5,8.6-46.6,25.3l-73,92.7l-73-92.7c-13.3-16.9-28.9-25.3-46.6-25.3 H56.3c-9.8,0-14.7,4.1-14.7,12.3c0,4.1,1.9,8.4,5.6,13.1l126.6,160.4L94.5,322.9l-55,70.1c-3.7,4.8-5.6,9.1-5.6,13 c1.1,8,6,12,14.9,12h56.8c17.8,0,33.2-8.3,46.4-25l81.3-103.7L314.5,393c13.1,16.7,28.6,25,46.4,25H447L292.7,221.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "319.9,222 396.2,318.9 396.2,125.1 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdc);
export default __webpack_public_path__ + "static/media/xdc.aae6af052e7b872f862627c092ed1e94.svg";
export { ForwardRef as ReactComponent };